import { useState, useEffect } from "react";
import { useGerenciamento } from "../Context/GerenciamentoContext";
import { Link, useNavigate } from 'react-router-dom';
import "../../App.css";
import "./Forms.css";

import FornecedorIcon from "../../assets/icons/fornecedores.png";
import FornecedoresService from "../../services/FornecedoresService";
import formFornecedorDTO from "../../types/FormFornecedorDTO";
import FornecedoresCategoriasService from "../../services/FornecedoresCategoriasService";
import formFornecedorUpdateDTO from "../../types/FormFornecedorUpdateDTO";

export default function FornecedoresForm({
  itemSelecionado,
  modo,
  onClose
}) {
  const [form, setForm] = useState({
    idFornecedor: null,
    idCategoriaFornecedor: "",
    nomeFantasia: "",
    razaoSocial: "",
    cnpjCpf: "",
    telefone: "",
    email: "",
    rua: "",
    numero: "",
    bairro: "",
    complemento: "",
    cep: "",
    cidade: "",
    uf: "",
    observacao: "",
    ativo: null,
  });

  const [categoria, setCategoria] = useState([]);
  const [CategoriaSelecionada, setCategoriaSelecionada] = useState(null);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [buscandoCep, setBuscandoCep] = useState(false);
  const { setRetorno } = useGerenciamento();
  const [submitState, setSubmitState] = useState("IDLE");

  // ==========================
  // LOAD MODO
  // ==========================
  useEffect(() => {
    if (modo === "novo") {
      setForm({
        idFornecedor: null,
        idCategoriaFornecedor: "",
        nomeFantasia: "",
        razaoSocial: "",
        cnpjCpf: "",
        telefone: "",
        email: "",
        rua: "",
        numero: "",
        bairro: "",
        complemento: "",
        cep: "",
        cidade: "",
        uf: "",
        observacao: "",
        ativo: null,
      });
    }

    if (modo === "alterar" && itemSelecionado) {
      setForm({
        idFornecedor: itemSelecionado.IDFORNECEDOR,
        idCategoriaFornecedor: itemSelecionado.IDCATEGORIAFORNECEDOR,
        nomeFantasia: itemSelecionado.NOME_FANTASIA,
        razaoSocial: itemSelecionado.RAZAO_SOCIAL,
        cnpjCpf: itemSelecionado.CNPJ_CPF,
        telefone: itemSelecionado.TELEFONE,
        email: itemSelecionado.EMAIL,
        rua: itemSelecionado.RUA,
        numero: itemSelecionado.NUMERO,
        bairro: itemSelecionado.BAIRRO,
        complemento: itemSelecionado.COMPLEMENTO ?? "",
        cep: itemSelecionado.CEP,
        cidade: itemSelecionado.CIDADE,
        uf: itemSelecionado.uf,
        observacao: itemSelecionado.OBSERVACAO ?? "",
        ativo: itemSelecionado.ATIVO,
      });
    }
  }, [modo, itemSelecionado]);


  // ==========================
  // Carregar Categoria Fornecedor
  // ==========================

  useEffect(() => {
    async function carregarDados() {
      try {
        const cat = await FornecedoresCategoriasService.getAll();
        setCategoria(cat);
      } catch (error) {
        console.error("Erro ao carregar dados:", error);
      }
    }
    carregarDados();
  }, []);


  // ==========================
  // Selecionar Categoria
  // ==========================
  function handleSelectCategoria(e){
    const id = Number(e.target.value);

      if (!id) {
      setCategoriaSelecionada(null);
      setForm(prev => ({ ...prev, idCategoriaFornecedor: ""}));
      return;
    }

    const c = categoria.find(a => a.IDCATEGORIAFORNECEDOR === id);
    setCategoriaSelecionada(c);

    if (c) {
      setForm(prev => ({
        ...prev,
        idCategoriaFornecedor: c.IDCATEGORIAFORNECEDOR,
      }));
    }
  }

  // ==========================
  // HANDLERS
  // ==========================
  function handleChange(e) {
    const { name, value } = e.target;

    if (name === "ativo") {
      setForm({ ...form, ativo: value === "true" });
      return;
    }

    setForm(prev => ({
      ...prev,
      [name]: value,
    }));
  }

  // ==========================
  // CEP
  // ==========================
  async function buscarCep() {
    const cepLimpo = form.cep.replace(/\D/g, "");

    if (cepLimpo.length !== 8) {
      alert("CEP inválido. Digite 8 números.");
      //setRetorno({ tipo: "erro", mensagem: "CEP inválido. Digite 8 números." });
      return;
    }

    try {
      setBuscandoCep(true);

      const resposta = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`);

      if (!resposta.ok) {
        alert("Erro ao consultar o CEP.");
        //setRetorno({ tipo: "erro", mensagem: "Erro ao consultar o CEP." });
        return;
      }

      const dados = await resposta.json();

      if (dados.erro) {
        alert("CEP não encontrado.");
        //setRetorno({ tipo: "erro", mensagem: "CEP não encontrado." });
        return;
      }

      setForm(prev => ({
        ...prev,
        rua: dados.logradouro || "",
        bairro: dados.bairro || "",
        cidade: dados.localidade || "",
        uf: dados.uf || "",
      }));
    } catch (error) {
      setRetorno({ tipo: "erro", mensagem: "Erro ao consultar o CEP." });
    } finally {
      setBuscandoCep(false);
    }
  }

  // ==========================
  // VALIDATION
  // ==========================
  function validarCampos() {
    const e = {};

    if (!form.nomeFantasia) e.nomeFantasia = "Informe o nome fantasia";
    if (!form.razaoSocial) e.razaoSocial = "Informe a razão social";
    if (!form.cnpjCpf) e.cnpjCpf = "Informe o CNPJ/CPF";

    return e;
  }

  // ==========================
  // SUBMIT
  // ==========================
  async function handleSubmit(e) {
    e.preventDefault();

    const validation = validarCampos();
    setErrors(validation);
    if (Object.keys(validation).length) return;

    setLoading(true);
    setSubmitState("IDLE");

    try {
      if (modo === "novo") {

        const payload_create = formFornecedorDTO ({
          IDCATEGORIAFORNECEDOR: form.idCategoriaFornecedor,
          NOME_FANTASIA: form.nomeFantasia, 
          RAZAO_SOCIAL: form.razaoSocial, 
          CNPJ_CPF: form.cnpjCpf, 
          TELEFONE: form.telefone,
          EMAIL: form.email, 
          RUA: form.rua,
          NUMERO: form.numero ? Number(form.numero) : null,
          BAIRRO: form.bairro, 
          COMPLEMENTO: form.complemento, 
          CEP: form.cep, 
          CIDADE: form.cidade,
          uf: form.uf,
          OBSERVACAO: form.observacao
        });


        await FornecedoresService.create(payload_create);
        setRetorno({ 
            tipo: "sucesso", 
            mensagem: "Fornecedor criado com sucesso!" 
          });
      }

      if (modo === "alterar") {

      const payload_update = formFornecedorUpdateDTO ({
          IDFORNECEDOR: form.idFornecedor,
          IDCATEGORIAFORNECEDOR: form.idCategoriaFornecedor,
          NOME_FANTASIA: form.nomeFantasia, 
          RAZAO_SOCIAL: form.razaoSocial, 
          CNPJ_CPF: form.cnpjCpf, 
          TELEFONE: form.telefone,
          EMAIL: form.email, 
          RUA: form.rua,
          NUMERO: form.numero ? Number(form.numero) : null,
          BAIRRO: form.bairro, 
          COMPLEMENTO: form.complemento, 
          CEP: form.cep, 
          CIDADE: form.cidade,
          uf: form.uf,
          OBSERVACAO: form.observacao,
          ATIVO: Boolean(form.ativo),
        });

        await FornecedoresService.update(form.idFornecedor, payload_update);
        setRetorno({ 
            tipo: "sucesso", 
            mensagem: "Fornecedor atualizado com sucesso!" 
          });
      }

      setSubmitState("SUCCESS");
      onClose();
    } catch {
      setRetorno({
        tipo: "erro",
        mensagem:
          modo === "novo"
            ? "Erro ao criar fornecedor."
            : "Erro ao atualizar fornecedor.",
      });
      setSubmitState("ERROR");
    } finally {
      setLoading(false);
    }
  }

  // ==========================
  // RENDER
  // ==========================
  return (
    <div className="Form-Interno-Container">
      <form onSubmit={handleSubmit}>
        <div className="Form-Interno-title">
          <img src={FornecedorIcon} alt="" className="icon" />
          {modo === "novo" ? "Cadastro de Fornecedor" : "Alterar Fornecedor"}
        </div>

        <div className="Form-Interno-linha"></div>


        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Categoria: *</div>
          <select
            value={form.idCategoriaFornecedor}
            onChange={handleSelectCategoria}
          >
            <option value="">Selecione uma categoria</option>
            {categoria.map(c => (
              <option key={c.IDCATEGORIAFORNECEDOR} value={c.IDCATEGORIAFORNECEDOR}>
                  {c.DESCRICAO}
              </option>
            ))}
          </select>
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Nome Fantasia *</div>
          <input name="nomeFantasia" value={form.nomeFantasia} onChange={handleChange} />
          {errors.nomeFantasia && <span className="erro">{errors.nomeFantasia}</span>}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Razão Social *</div>
          <input name="razaoSocial" value={form.razaoSocial} onChange={handleChange} />
          {errors.razaoSocial && <span className="erro">{errors.razaoSocial}</span>}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">CNPJ / CPF *</div>
          <input name="cnpjCpf" value={form.cnpjCpf} onChange={handleChange} />
          {errors.cnpjCpf && <span className="erro">{errors.cnpjCpf}</span>}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Telefone</div>
          <input name="telefone" value={form.telefone} onChange={handleChange} />
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">E-mail</div>
          <input name="email" value={form.email} onChange={handleChange} />
        </div>

        <div className="Form-Interno-alinhamento-cep">
          <div className="Form-Interno-label">CEP</div>
          <div style={{ display: "flex", gap: "10px" }}>
            <input
              name="cep"
              value={form.cep}
              onChange={handleChange}
              maxLength={9}
              placeholder="00000-000"
              className="cep"
            />
            <button type="button" onClick={buscarCep} disabled={buscandoCep}>
              {buscandoCep ? "Buscando..." : "Buscar"}
            </button>
          </div>
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Rua</div>
          <input name="rua" value={form.rua} onChange={handleChange} />
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Número</div>
          <input name="numero" value={form.numero} onChange={handleChange} />
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Bairro</div>
          <input name="bairro" value={form.bairro} onChange={handleChange} />
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Complemento</div>
          <input name="complemento" value={form.complemento} onChange={handleChange} />
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Cidade</div>
          <input name="cidade" value={form.cidade} onChange={handleChange} />
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">UF</div>
          <input name="uf" maxLength={2} value={form.uf} onChange={handleChange} />
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Observação</div>
          <input name="observacao" value={form.observacao} onChange={handleChange} />
        </div>

        {modo === "alterar" && (
          <div className="Form-Interno-alinhamento">
            <div className="Form-Interno-label">Ativo</div>
            <select name="ativo" value={String(form.ativo)} onChange={handleChange}>
              <option selected value="">Selecione</option>
              <option value="true">Sim</option>
              <option value="false">Não</option>
            </select>
          </div>
        )}

        <div className="Form-Interno-alinhamento-button">
          <button type="submit" disabled={loading} className="Form-Interno-button">
            {loading ? "Enviando..." : "Salvar"}
          </button>

          <button type="button" className="Form-Interno-button" onClick={onClose}>
            Voltar
          </button>
        </div>
      </form>
    </div>
  );
}
